import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { beginning_q1 } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformBeginningQ1() {
    const { t } = useTranslation('settings');

    const options = beginning_q1(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'beginning_q1'}
            control={control}
            name={'beginning_q1'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.beginning_q1')}
                        error={errors.beginning_q1?.message}
                        options={options}
                        panelOptions={{ placement: 'top' }}
                    />
                );
            }}
        />
    );
}
